import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ICorDaRota } from 'src/app/coleta/agendamento/model/cor-da-rota.interface';

@Component({
  selector: 'app-label-avatar',
  templateUrl: './label-avatar.component.html',
  styleUrls: ['./label-avatar.component.css']
})
export class LabelAvatarComponent implements OnInit, OnChanges {

  @Input() id: number = null;
  @Input() nome = '';
  @Input() cor: ICorDaRota = null;
  @Input() title = '';
  @Input() isClickable = false;
  
  public primeiraLetra = '';
  public segundaLetra  = '';

  public cssClass = '';

  constructor() { }

  ngOnInit(): void {
    if ( this.isClickable ) {
      this.cssClass = 'click';
    }

    this.carregarDados();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if ( !changes?.nome?.firstChange || 
         !changes?.id?.firstChange ) {
      this.carregarDados();
    }
  }

  private removerEspacoDuplicado(nome: string): string {
    if (nome && nome.indexOf('  ') >=0 ) {
      nome = nome.replace('  ', ' ');
      
      return this.removerEspacoDuplicado( nome );
    }
    
    return nome;
  }

  private carregarDados(): void {
    if ( !this.nome ) {
      return;
    }
    this.nome = this.removerEspacoDuplicado( this.nome );
    this.primeiraLetra = this.nome.substring(0, 1).toUpperCase();

    try {
      if ( this.nome.indexOf(' ') > 0 ) {
        this.segundaLetra = this.nome.split(' ')[1].substring(0, 1).toUpperCase();
      }
      else {
        this.segundaLetra = this.nome.substring(1, 2).toUpperCase();
      }
    }
    catch(e) {
      console.error('app-label-avatar', e);
    }

    if ( !this.title ) {
      this.title = ( this.id ? this.id + ' - ' : '' );
      this.title += this.nome;
    }
  }


}
